// Map a Trace chip's semantic TONE (from the shared, token-agnostic
// `tracePresentation`) to a P0a token custom property, so the evidence surface
// stays driven by `[data-appearance]`. PURE + testable.
//
// On the Evidence surface, amber
// (`signal.attention`) means EXACTLY "an agent needs you" and nothing else
// competes. A `halt` IS a needs-you state, so `danger` (operator_halt) is the
// ONE tone that maps to amber. Every other tone — proof, the operator catches
// (flag/suggestion/reach), corpus — drains to neutral text ink. There is no
// second saturated signal here.

import type { TraceTone } from "@waytide/core/tracePresentation";

/** The CSS custom-property reference a Trace `tone` paints its chip with. On
 * Evidence, amber is the ONLY signal and marks a halt (needs-you); everything
 * else is neutral ink. */
export function toneColorVar(tone: TraceTone): string {
  switch (tone) {
    case "danger": // operator_halt — a halt IS a needs-you state → the one amber
      return "var(--waytide-sys-signal-attention)";
    case "success": // proof ✓ — a record, not a competing signal → neutral
    case "supervisor": // Supervisor raised a flag → neutral
    case "arbiter": // an arbiter offered a better way (shared tone) → neutral
    case "signal": // Signal reached the human → neutral
    case "neutral":
    default:
      return "var(--waytide-sys-text-secondary)";
  }
}
